import { useEffect, useState } from "react";
import { decryptData, defaulUrl, encryptData, formatMoney, onfocus } from "../components/const";
import UseFetch from "../components/UseFetch";
import Swal from "sweetalert2";
import ModalAddClient from "../Clients/ModalAddClient";
import Select from "react-select";



const Facturation = () => {
    const id = decryptData('user_profile').idmagasin;
    const { data, isloading } = UseFetch(`factures/get-data/${id}`);

    const produits = data?.produits || [];
    const clients = data?.clients || []


    const infoConteneur = [...new Map(produits?.map(p => ({ id: p.idconteneur, numero: p.numero, conteneur: p.conteneur })).map(o => [o.numero, o])).values()];

    const savedState = decryptData("facturation_state");
    // ⚡ State initialisé avec localStorage
    const [selected, setSelect] = useState(() => savedState?.selected || []);
    const [selectedConteneur, setSelectedConteneur] = useState(() => savedState?.selectedConteneur || null);
    const [client, setClient] = useState(() => savedState?.client || { value: '978', label: 'CLIENT PASSAGER' });
    const [total, setTotal] = useState(() => savedState?.total || 0);
    const [remise, setRemise] = useState(() => savedState?.remise || 0);
    const [net, setNet] = useState(() => savedState?.net || 0);
    const [paye, setPaye] = useState(() => savedState?.paye || 0);
    const [surplus, setSurplus] = useState(() => savedState?.surplus || 0);
    const [sourceSolde, setSourceSolde] = useState(() => savedState?.sourceSolde || false);
    const [gonext, setGonext] = useState(() => savedState?.gonext || false);
    const [produitsParConteneur, setProduitsParConteneur] = useState(() => savedState?.produitsParConteneur || null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [total_qte, setQteTotal] = useState(0);

    // 💾 Sauvegarde automatique à chaque changement de state
    useEffect(() => {
        const stateToSave = {
            selected,
            selectedConteneur,
            client,
            total,
            remise,
            net,
            paye,
            surplus,
            produitsParConteneur,
            sourceSolde,
            gonext
        };
        setQteTotal(selected.reduce((acc, curr) => acc + curr.quantite, 0));

        encryptData("facturation_state", stateToSave)

    }, [selected, selectedConteneur, client, total, remise, net, paye, surplus, sourceSolde, gonext, produitsParConteneur]);

    //  Recalcul automatique
    useEffect(() => {
        let totalBase = 0;
        let totalRemise = 0;
        let totalSurplus = 0;

        selected.forEach(p => {
            const q = p.quantite;
            const prix = p.pvu;
            const prixMag = p.pvu_m;

            totalBase += q * prixMag;

            if (prix < prixMag) totalRemise += (prixMag - prix) * q;
            else if (prix > prixMag) totalSurplus += (prix - prixMag) * q;
        });

        setTotal(totalBase);
        setRemise(totalRemise);
        setSurplus(totalSurplus);
        setNet(totalBase - totalRemise + totalSurplus);
    }, [selected]);


    const handleSelectConteneur = (cont) => {
        setSelectedConteneur({
            label: cont.label,
            value: cont.value
        })
        setProduitsParConteneur([])
    }

    const handleshowProducts = () => {
        if (!selectedConteneur) return setError('Veuillez choisir un conteneur!');
        setError(null);
        setProduitsParConteneur(produits?.filter(p => +p.idconteneur === +selectedConteneur.value));
        setSelect([]);
    };

    const handSelect = (prod) => {
        if (!selected.some(p => p.idstock === prod.id && p.produit === prod.produit)) {
            setSelect([...selected, {
                idproduit: prod.idproduit,
                produit: prod.produit,
                quantite: 1,
                pau: prod.pau,
                pvu_m: prod.pvu,
                pvu: prod.pvu,
                idstock: prod.id,
                qte_total: +prod.stock,
                idconteneur: prod.idconteneur
            }]);
        }
    };

    const handleQte = (e, prod) => {
        const value = +e.target.value;
        recalcMontants(prod.idstock, value, prod.pvu);
    };

    const handlePrix = (e, prod) => {
        const value = +(e.target.value.replace(/\D/g, ""));
        recalcMontants(prod.idstock, prod.quantite, value);
    };

    const recalcMontants = (idstock, quantite, pvu) => {
        setSelect(prev =>
            prev.map(p =>
                p.idstock === idstock ? { ...p, quantite, pvu } : p
            )
        );
    };

    const handleReset = () => {
        setTotal(0);
        setRemise(0);
        setNet(0);
        setPaye(0);
        setSelect([]);
        setGonext(false);
        setIsLoading(false);
        setClient({ value: '978', label: 'PASSANT' });
        setSourceSolde(false);
        setSurplus(0);
        setSelectedConteneur(null);
        setProduitsParConteneur(null);
    };

    const handleSave = () => {
        if (!client) return Swal.fire({ title: "Client manquant", text: "Veuillez choisir un client", icon: "error" });

        const overStock = selected.find(p => p.quantite > p.qte_total);
        if (overStock) return Swal.fire({ title: "Stock insuffisant", text: "Quantité supérieure au stock.", icon: "error" });

        if (total <= remise) return Swal.fire({ title: "Erreur de remise", text: "Remise trop élevée.", icon: "error" });
        if (net < paye) return Swal.fire({ title: "Paiement invalide", text: "Montant payé supérieur au net.", icon: "error" });
        if (+client?.value === 978 && paye < net) return Swal.fire({ title: "Client passager", text: "Doit payer la totalité.", icon: "error" });
        if (sourceSolde && paye > client?.solde) return Swal.fire({ title: "Solde insuffisant", text: `Solde actuel: ${client?.solde?.toLocaleString()} GNF`, icon: "error" });

        const facture = {
            montant: total,
            remise,
            montant_net: net,
            paye,
            source: sourceSolde,
            idmagasin: id,
            idconteneur: +selectedConteneur.value,
            surplus
        };

        setIsLoading(true);

        fetch(`${defaulUrl}factures/add`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            },
            body: JSON.stringify({ idclient: client.value, facture, selected })
        })
            .then(res => res.json().then(data => ({ status: res.status, body: data })))
            .then(({ status, body }) => {
                setIsLoading(false);
                if (status === 200) {
                    Swal.fire({ title: "Succès", text: body.message, icon: "success" });
                    handleReset();
                } else {
                    Swal.fire({ title: "Erreur", text: body.message, icon: "error" });
                }
            })
            .catch(() => {
                setIsLoading(false);
                Swal.fire({ title: "Erreur", text: "Une erreur s'est produite.", icon: "error" });
            });
    };

    return (
        <div className="Facturation container-fluid plage">
            {(isLoading || isloading) && <div className="loader"></div>}
            {selected?.length > 0 && <div className="fst-italic h6 text-muted">{selected.length} produit(s) sélectionné(s)</div>}

            {!gonext && (

                <div className="row">
                    <h4 className="text-secondary text-center">CREATION DE FACTURE</h4>
                    <div className="row align-items-center">

                        <div className="col-lg-6">
                            <div className="row justify-content-end">
                                <div className="col">
                                    <label>Choisir un conteneur</label>
                                    <Select
                                        value={selectedConteneur ? {
                                            label: selectedConteneur.label,
                                            value: selectedConteneur.value
                                        } : null}
                                        options={infoConteneur.map(cont => ({ value: `${cont.id}`, label: `${cont.conteneur}` }))}
                                        onChange={handleSelectConteneur}
                                        placeholder="Sélectionner..."
                                    />
                                    {error && <span className="text-danger">{error}</span>}
                                </div>
                                <button className="btn btn-primary w-auto h-50 mt-auto" onClick={handleshowProducts}>
                                    <i className="bx bx-show"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    {selectedConteneur ? (
                        <div className="my-1 p-1">
                            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4">
                                {produitsParConteneur.map((prod, index) => {
                                    const dejaAuPanier = selected.some(p => p.idstock === prod.id);
                                    return (
                                        <div key={index} className="col p-1 radius-15 m-0 prod">
                                            <div className="card h-100 p-2 border-0 d-flex flex-column align-items-center">
                                                <span className="text-center prod-name">{prod.produit}</span>
                                                <small className="fw-bold text-secondary">Qte: {prod.stock}</small>
                                                <strong className="prix">{`${prod.pvu.toLocaleString()} GNF`}</strong>

                                                {dejaAuPanier ? (
                                                    <button className="mt-auto btn btn-success" disabled> <i className="bx bx-check"></i> </button>
                                                ) : (
                                                    <button
                                                        className="mt-auto btn btn-outline-success"
                                                        onClick={() => handSelect(prod)}
                                                    >
                                                        Ajouter
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}

                            </div>
                        </div>
                    ) : (
                        <div className="row p-2 justify-content-center bg-primary-subtle text-danger fs-3 mt-2">
                            Aucun conteneur sélectionné!
                        </div>
                    )}
                </div>
            )}

            {gonext && <div className="row">
                <fieldset className="border rounded bg-secondary-subtle w-100">
                    <div className="row px-2 my-2 align-items-center">
                        <label htmlFor="client" className="fs-4">Client </label>
                        <div className="col-lg-6">
                            <div className="input-group">

                                <Select
                                    className="fact-clien-input"
                                    value={client ? {
                                        label: client.label,
                                        value: client.value
                                    } : null}
                                    options={clients?.map((client) => ({
                                        value: `${client.id}`,
                                        label: `${client.client}(${client.telephone})`,
                                        solde: client.solde
                                    }))}
                                    onChange={setClient}
                                />

                                <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalAddClient">
                                    <i className="bx bx-plus-circle"></i>
                                </button>
                            </div>
                        </div>
                        {client.solde > 0 && <div className="col-lg-4 d-flex gap-1 px-2 py-auto">
                            <input type="checkbox" className="form-check-input my-auto" onChange={(e) => setSourceSolde(e.target.checked)} />
                            <label className="text-primary fs-6">Payer via solde client (Solde: {client.solde.toLocaleString()} GNF) </label>
                        </div>}
                    </div>
                </fieldset>

                <div className="table-responsive p-2 bg-white">
                    <table className="table table-white table-hover table-striped ">
                        <thead className="table-primary">
                            <tr>
                                <th>N°</th>
                                <th>PRODUITS</th>
                                <th>STOCK</th>
                                <th>QTE</th>
                                <th>PVU(GNF)</th>
                                <th>MONTANT(GNF)</th>
                                <th>ACTIONS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selected?.map((prod, ind) => {

                                return <tr key={ind} className="align-middle">
                                    <td>{ind + 1}</td>
                                    <td>{prod.produit}</td>
                                    <td>{prod.qte_total}</td>
                                    <td>
                                        <input type="number" min={1} max={prod.qte_total} className="form-control qte" value={prod.quantite} onChange={(e) => handleQte(e, prod)} />
                                    </td>
                                    <td>
                                        <input type="text" className="form-control prix" value={prod.pvu.toLocaleString()} onChange={(e) => handlePrix(e, prod)} onBlur={(e) => { formatMoney(e); recalcMontants(prod.idstock, prod.quantite, prod.pvu); }} onFocus={(e) => onfocus(e)} />
                                    </td>
                                    <td>{(prod.pvu * prod.quantite).toLocaleString()} GNF</td>
                                    <td className="text-end">
                                        <i className="bx bx-trash mx-auto p-1 m-1 bg-danger-subtle rounded text-danger fs-5"
                                            onClick={() => setSelect(selected.filter(p => p.idstock !== prod.idstock))}></i>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>

                {/* Section totaux */}
                <div className="row p-2 bg-white m-auto align-items-center row-cols-1 row-cols-md-6 py-2 shadow ">

                    <div className="col">

                        <label class="small">Quantité total</label>
                        <div className="input-group">
                            <input type="text" className="form-control" value={total_qte.toLocaleString()} disabled />
                            <span className="input-group-text"></span>
                        </div>

                    </div>
                    <div className="col">

                        <label class="small">Total Prix machine</label>
                        <div className="input-group">
                            <input type="text" className="form-control" value={total.toLocaleString()} disabled />
                            <span className="input-group-text">GNF</span>
                        </div>

                    </div>
                    <div className="col" hidden>

                        <label class="small">Total PVU</label>
                        <div className="input-group">
                            <input type="text" className="form-control" value={total.toLocaleString()} disabled />
                            <span className="input-group-text">GNF</span>
                        </div>

                    </div>
                    <div className="col">
                        <label class="small">Total Surplus</label>
                        <div className="input-group">
                            <input type="text" className="form-control" value={surplus.toLocaleString()} onBlur={(e) => formatMoney(e)} onFocus={(e) => onfocus(e)} disabled />
                            <span className="input-group-text">GNF</span>
                        </div>

                    </div>
                    <div className="col">

                        <label class="small">Total Remise</label>
                        <div className="input-group">
                            <input type="text" className="form-control" value={remise.toLocaleString()} onFocus={(e) => onfocus(e)} disabled />
                            <span className="input-group-text">GNF</span>
                        </div>

                    </div>
                    <div className="col">

                        <label class="small">Net à payer</label>
                        <div className="input-group">
                            <input type="text" className="form-control" value={net.toLocaleString()} disabled />
                            <span className="input-group-text">GNF</span>
                        </div>
                    </div>
                    <div className="col">
                        <div className="form-group">
                            <label class="small">Payé</label>
                            <div className="input-group">
                                <input type="text" className="form-control" value={paye} onChange={(e) => setPaye(+e.target.value.replace(/\s/g, ""))} onBlur={(e) => formatMoney(e)} onFocus={(e) => onfocus(e)} />
                                <span className="input-group-text">GNF</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }
            <div className="row justify-content-end p-2 mt-5">
                <div className="modal-footer">
                    {!gonext && selected.length > 0 && (
                        <button className="btn btn-primary m-1 btn-card" onClick={() => setGonext(true)}>
                            <i className="bx bx-cart-alt fs-1"></i>
                            <span className="text-warning p-1">{selected.length}</span>
                        </button>
                    )}
                    {gonext && <button className="btn btn-danger m-1" onClick={() => setGonext(false)}><i className="bx bx-first-page"></i> Retour</button>}
                    {selected.length > 0 && gonext && <button className="btn btn-success m-1" onClick={handleSave} disabled={isLoading}>Enregistrer</button>}
                </div>
            </div>
            <ModalAddClient isnew={true} listClient={clients} />
        </div>
    );
};

export default Facturation;
